import { createSlice } from "@reduxjs/toolkit";

import {
  getDatafeedOrganizationConfig,
  getDataFeedStatsPerformFilters,
  getDataFeedStatsPerformMatchId,
  getDataFeedStatsPerformSoccerFilters,
  getDataFeedVolleyStationFilters,
} from "./actions";

const initialState = {
  organizationConfigs: [],
};

const datafeedSlice = createSlice({
  name: "datafeed",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDataFeedStatsPerformFilters.fulfilled, (state, action) => {
      if (!action.payload?.error) {
        Object.assign(state, action.payload.data);
      }
    });
    builder.addCase(getDataFeedStatsPerformSoccerFilters.fulfilled, (state, action) => {
      if (!action.payload?.error) {
        Object.assign(state, action.payload.data);
      }
    });
    builder.addCase(getDataFeedStatsPerformMatchId.fulfilled, (state, action) => {
      if (!action?.payload?.error) {
        Object.assign(state, { id: action?.payload?.data });
      } else {
        Object.assign(state, { id: null });
      }
    });
    builder.addCase(getDataFeedVolleyStationFilters.fulfilled, (state, action) => {
      if (!action?.payload?.error) {
        Object.assign(state, action.payload.data);
      }
    });
    builder.addCase(getDatafeedOrganizationConfig.fulfilled, (state, action) => {
      if (!action?.payload?.error) {
        Object.assign(state, { organizationConfigs: action.payload.data });
      }
    });
  },
});

export default datafeedSlice.reducer;
